import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '@argalis-apps/angular-global';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DevisService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getListByIdClient(idclient: string | number) {
    // let params = new HttpParams();
    // params = params.append('idclient', idclient.toString());
    // params = params.append('extranet', true.toString());
    return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/devis/devis-list`, {
      params: { idclient: idclient.toString(), extranet: 'true' }
    });
  }
}
